<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
    export let row = {};
</script>

<a href="{`${PATH_PREFIX}/sw/builder/activityversion/${row.id}/detail`}" target="_blank" rel="noopener noreferrer">{row.name}</a>